import React from 'react';
import { FlashSalesCounterEvolution } from '@/app/common/components/Promotions/FlashSalesCounter';
import { createFlashSalesConfig } from '@/app/common/components/Promotions/FlashSalesCounter/utils.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import type { BadgeContext } from '../types';

/** Flash-sales countdown badge used in the price area */
const FlashSalesCountdownBadge = ({ dealCard }: BadgeContext) => {
  const { t } = useTranslation();
  const flashSalesConfig = createFlashSalesConfig(dealCard, t);
  return <FlashSalesCounterEvolution flashSalesConfig={flashSalesConfig} />;
};

export default FlashSalesCountdownBadge;
